import React from "react";

import { Tab, TabProps, TabTypeMap } from "@mui/material";

import { IgBadge } from "./IgBadge";

export type IgTabProps<
  RootComponent extends React.ElementType = TabTypeMap["defaultComponent"],
> = TabProps<
  RootComponent,
  {
    hasBadge?: boolean;
  }
>;

export const IgTab = <
  RootComponent extends React.ElementType = TabTypeMap["defaultComponent"],
>(
  props: IgTabProps<RootComponent> & {
    component?: RootComponent;
  }
) => {
  const { label, hasBadge, sx, ...rest } = props;

  return (
    <Tab
      data-label={label}
      iconPosition={"end"}
      icon={
        hasBadge ? (
          <IgBadge
            variant={"dot"}
            color={"accent"}
            sx={{ pr: 1, mt: "-5px" }}
          />
        ) : undefined
      }
      label={label}
      {...rest}
    />
  );
};
